module.exports = "/assets/data/669d0c0098e8a69455aaa3a79f09719f-SE20.data.json";